import { dataHooks } from '../../../../../../libs/dataHooks';

export const highlightSearchCriteriaDataHooks = dataHooks<{
  highlighted: {};
}>('highLightListItem');
